let parser = require('ua-browser');
let _ = require('lodash');

/**
 * Прокрутка страницы до нужной высоты, в случае, если `to` больше высоты страницы, скроллимся до низа
 * @param  {Number} to до какой высоты прокручивать
 * @param  {Number} duration
 */
exports.scrollTo = (to, duration) => {
    var browser = parser(window.navigator.userAgent).browser;
    var body = _.includes(['Firefox', 'IE', 'Chrome'], browser.name) ? document.documentElement : document.body;
    var scrollTo = Math.min(body.scrollHeight - body.clientHeight, to);

    function scrollTick (tmpTo, tmpDuration) {
        var diffTop = body.scrollTop;
        var difference = tmpTo - diffTop;
        var perTick = Math.round(difference / tmpDuration * 10);

        setTimeout(() => {
            var previousTop, top;

            previousTop = body.scrollTop;
            body.scrollTop += perTick;
            top = body.scrollTop;

            if (top == Math.round(tmpTo) || top == previousTop) {
                return;
            }

            scrollTick(tmpTo, tmpDuration - 10);
        }, 10);
    }

    scrollTick(scrollTo, duration);
};



// WEBPACK FOOTER //
// ./helpers/windowUtils.js